import { useState } from 'react'

import GeneralLocationsImage from 'src/features/business/referrals/assets/send-referral/general-locations.png'
import SpecificPropertyImage from 'src/features/business/referrals/assets/send-referral/specific-property.png'
import { Button } from 'src/shared/components/ui/buttons/button'

import { GeneralLocationsForm } from './property-info/general-locations-form'
import { SpecificPropertyForm } from './property-info/specific-property-form'

export const PropertyInfo = () => {
  const [mode, setMode] = useState<'general' | 'specific'>('general')

  return (
    <div className="mb-24 space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <Button
          type="button"
          variant={mode === 'general' ? 'fadedSecondary' : 'accent'}
          aria-selected={mode === 'general'}
          onClick={() => setMode('general')}
          className="flex h-24 flex-col items-center justify-center"
        >
          <div className="flex flex-col items-center justify-center gap-2">
            <img src={GeneralLocationsImage} alt="General Locations" width={32} height={32} />
            <span className="line-clamp-2 text-center font-medium">{'General Location(s)'}</span>
          </div>
        </Button>

        <Button
          type="button"
          variant={mode === 'specific' ? 'fadedSecondary' : 'accent'}
          aria-selected={mode === 'specific'}
          onClick={() => setMode('specific')}
          className="flex h-24 flex-col items-center justify-center"
        >
          <div className="flex flex-col items-center justify-center gap-2">
            <img src={SpecificPropertyImage} alt="Specific Property" width={32} height={32} />
            <span className="line-clamp-2 text-center font-medium">Specific Property</span>
          </div>
        </Button>
      </div>
      {mode === 'specific' ? <SpecificPropertyForm /> : <GeneralLocationsForm />}
    </div>
  )
}
